import { useEffect } from 'react'

export default function ThemeController() {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const theme = entry.target.dataset.sectionTheme || 'dark'
                        document.documentElement.dataset.theme = theme
                    }
                })
            },
            { threshold: 0.5 }
        )
        const sections = document.querySelectorAll('section[data-section-theme]')
        sections.forEach((el) => observer.observe(el))
        return () => observer.disconnect()
    }, [])

    return null
}
